import { urlHelper } from '@/helpers/apiHelpers/urlHelper';

export const getInboundWireDetailsPath = (transactionId: string = ':transactionId', id: string = ':id') => {
  return urlHelper(`/transactions/${transactionId}/inbound-wires/${id}/details`);
};
